import { Feature } from '@/@types/featureSwitch';
import { InsuranceType } from '@/@types/insurance';
import { OfferType, UpsellOfferOrigin } from '@/@types/upsellOffer';
import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { useGetUpsellOffer } from '@/apiHooks/upsellOffer.hook';

export const useADACModalHook = (offerEnabled: boolean) => {
  const wohnenPlusADACExperimentEnabled = useFeature(Feature.ADAC_ASSIGMENT);
  const forceADACPreview = useFeature(Feature.ADAC_ASSIGMENT_FORCE_MODAL_PREVIEW);
  // Safe to call alongside WelcomeModal: React Query shares cached data and in-flight
  // requests for the same upsell-offer key. Keep the same enabled condition as the caller.
  const { upsellOffer } = useGetUpsellOffer(UpsellOfferOrigin.MEIN_PLUS, OfferType.WOHNEN_PLUS, offerEnabled);

  // FIXME: Implement the call to the backend to verify if the ADAC is already bought
  //  ADAC being already bought should be a hard stop in removing the modal completely
  const hasADACActive = false;
  const isEligibleForADACOffer =
    upsellOffer?.showOffer && upsellOffer?.isEligible && upsellOffer?.insuranceType === InsuranceType.ADAC;
  const canShowADAC = forceADACPreview || (wohnenPlusADACExperimentEnabled && !hasADACActive && isEligibleForADACOffer);

  return { canShowADAC };
};
